import fetch from 'isomorphic-fetch'
import { types } from '../../../constants/ActionTypes'
import { getRootURL } from '../../../lib'
import { tokenSilentlyOption } from '../../../lib/Auth0'

export const init = () => ({
  type: types.paypal.INIT,
})

export const changedPlan = (planID) => ({
  type: types.paypal.CHANGED_PLAN,
  planID
})

export const changedAmount = (amount) => ({
  type: types.paypal.CHANGED_AMOUNT,
  amount
})

export const createSubscription = (actions) => (dispatch, getState) => {
  const { planID } = getState().paypal

  return actions.subscription.create({
    plan_id: planID,
    application_context: {
      shipping_preference: "NO_SHIPPING",
      brand_name: "Renju Portal",
      locale: "ja-JP",
    }
  })
}

export const createOrder = () => (dispatch, getState) => {
	var body
  
  const state = getState()
  const { planID, amount } = state.paypal
  const auth0 = state.authentication.auth0
  if (!auth0) return
  return auth0.getTokenSilently(tokenSilentlyOption)
  .then(accessToken => {
		body = { orderName: planID, amount }
		return fetch(getRootURL() + '/paypal/order/create', {
			method: 'POST',
			headers: {
        "Content-Type": "application/json",
        Authorization: 'Bearer ' + accessToken
			},
			body: JSON.stringify(body),
		})
	})
	.then(response => response.json())
	.then(json => {
		return Promise.resolve(json)
	})
}

export const approveOrder = (data) => (dispatch, getState) => {
	var body
	
  const auth0 = getState().authentication.auth0
  if (!auth0) return
  auth0.getTokenSilently(tokenSilentlyOption)
  .then(accessToken => {
		body = { ...data }
		return fetch(getRootURL() + '/paypal/order/approve', {
			method: 'POST',
			headers: {
        "Content-Type": "application/json",
        Authorization: 'Bearer ' + accessToken
			},
			body: JSON.stringify(body),
		})
	})
	.catch((error) => {
		console.dir(error)
	})
}


export const approveSubscription = (data) => (dispatch, getState) => {
	var body
	
  const auth0 = getState().authentication.auth0
  if (!auth0) return
  auth0.getTokenSilently(tokenSilentlyOption)
  .then(accessToken => {
		body = { ...data }
		return fetch(getRootURL() + '/paypal/subscription/approve', {
			method: 'POST',
			headers: {
        "Content-Type": "application/json",
        Authorization: 'Bearer ' + accessToken
			},
			body: JSON.stringify(body),
		})
	})
	.catch((error) => {
		console.dir(error)
	})
}





// WEBPACK FOOTER //
// ./src/Parts/PayPalCard/actions/index.js